import React from "react";

import "./style.scss";

export const Field = ({ className = "", children }) => {
  return <div className={`field-container ${className}`}>{children}</div>;
};
